import React, { PureComponent } from "react";
import styles from "./styles.css";
import t from "@zendesk/client-i18n-tools";

export default class NoResults extends PureComponent {
  render() {
    return (
      <div
        className={styles.noResults}
        data-test-id="article-matches-no-results"
      >
        {t("knowledge-verification.noMatchingArticlesFound")}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleMatches/NoResults.js